var _g, _path, _path2, _g2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomerPtp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 45,
    viewBox: "0 0 68 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_857_909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.2118 35.2878L56.0011 35.2764V35.4875V39.1151L54.564 38.7958L52.0697 35.1436L52.0137 35.0616L51.9145 35.0566L33.0554 34.1136C32.1984 34.0708 31.4233 33.5917 31.0017 32.8444C30.749 32.3964 30.6406 31.8815 30.6911 31.3697L31.8964 19.1637C32.1102 16.9982 33.8292 15.2882 35.9958 15.0858L58.7487 12.96C58.9628 12.94 59.178 12.9352 59.3928 12.9457L61.0912 13.0285C61.2397 13.0358 61.3865 13.0621 61.5283 13.1068C62.2489 13.3343 62.7389 14.0028 62.7389 14.7585V30.8437C62.7389 33.4492 60.5525 35.5212 57.9507 35.3813L56.2118 35.2878Z",
    fill: "#EBEEF2",
    stroke: "#6AC5AB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4338 34.8695L54.223 34.8582V35.0692V38.4783L50.2647 34.6936L50.2111 34.6424L50.1372 34.6384L34.8038 33.8137C32.3925 33.684 30.5037 31.6909 30.5037 29.2761V19.2438C30.5037 16.8621 32.3426 14.8845 34.7181 14.7116L56.0868 13.1567C58.7194 12.9651 60.9608 15.0493 60.9608 17.6889V30.4254C60.9608 33.031 58.7744 35.103 56.1726 34.963L54.4338 34.8695Z",
    fill: "white",
    stroke: "#6AC5AB",
    strokeWidth: 0.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7577 20.8407L51.9428 20.6904C52.1668 20.6904 52.3501 20.8877 52.3501 21.1309L52.3516 29.1178C52.3516 29.3608 52.169 29.5582 51.9443 29.5582L49.7577 29.3399C49.5329 29.3399 49.3504 29.1426 49.3504 28.8995V21.2812C49.3504 21.038 49.5337 20.8407 49.7577 20.8407Z",
    fill: "#6AC5AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2037 21.3891C41.264 21.378 44.1397 21.2068 44.1397 21.2068L43.7457 20.0364C43.4739 19.2282 43.6499 17.994 44.4042 17.5552C44.6498 17.4123 44.9929 17.3406 45.2696 17.4164C45.4283 17.4599 45.5677 17.5742 45.6508 17.7275C45.7464 17.9037 45.7365 18.1094 45.7706 18.3048C45.8569 18.8005 46.072 19.2717 46.4051 19.6254C46.9859 20.2421 48.79 21.2068 48.79 21.2068V28.7534L42.5555 28.5378C41.7142 28.5383 41.1629 27.5155 41.5778 26.7165C41.0832 26.3716 40.9141 25.6452 41.2037 25.0874C40.7091 24.7425 40.54 24.016 40.8297 23.4583C40.0846 22.8303 40.2066 21.5727 41.2037 21.3891Z",
    fill: "#6AC5AB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_857_909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 7.65385C3 4.91817 5.3075 2.74938 8.03794 2.91878L29.5726 4.25476C32.2515 4.42095 34.2591 6.77445 34.001 9.44601L32.8691 21.1631C32.6342 23.5952 30.5904 25.4511 28.1469 25.4511H14.2056L11.0875 30.9115L9.04129 31.6017V25.4511H7.74418C5.12404 25.4511 3 23.3271 3 20.7069V7.65385Z",
    fill: "#6AC5AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6.76062C3 5.04016 3.58464 2.30659 7.48225 2.20898L30.5756 3.67341C32.6307 3.8009 34.4732 6.16655 34.4732 8.22957L35.6997 21.2118C35.7264 21.4946 35.7328 21.7819 35.6887 22.0626C35.2139 25.0874 32.6353 25.4511 30.5756 25.4511H14.2056L11.0875 30.9115L9.04129 31.6017V25.4511H6.89761C4.74502 25.4511 3 23.7027 3 21.546V6.76062Z",
    fill: "#6AC5AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9873 7.04729C4.9873 4.31173 7.2946 2.14299 10.0249 2.31218L32.0213 3.67531C34.5226 3.83033 36.472 5.90422 36.472 8.41041V20.084C36.472 22.7042 34.3479 24.8282 31.7278 24.8282H16.197L11.0308 30.9743V24.8282H9.73148C7.11134 24.8282 4.9873 22.7042 4.9873 20.084V7.04729Z",
    fill: "#004357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9873 6.15136C4.9873 3.90135 6.88345 2.11751 9.1273 2.25656L32.8139 3.72444C34.8698 3.85184 36.472 5.55773 36.472 7.61924V20.926C36.472 23.0811 34.7263 24.8282 32.573 24.8282H16.197L11.0308 30.9743V24.8282H8.88634C6.73296 24.8282 4.9873 23.0811 4.9873 20.926V6.15136Z",
    fill: "#004357"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8457 15.9754C25.8457 14.4958 24.5827 13.6776 23.0588 13.3077V10.8891C23.7453 10.9745 24.4591 11.2163 25.1593 11.6289L25.8457 10.0724C24.9844 9.29125 23.6109 8.73468 23.0588 8.73468V7.46045H21.686V8.55747C19.5169 8.81355 18.2677 9.79215 18.2676 11.6289C18.2676 14.4116 20.1621 14.6592 21.686 15.0433V17.1247C20.6976 17.0251 19.6032 16.7363 18.9168 16.2099L18.2676 18.3076C19.0226 18.9194 20.3269 19.3901 21.686 19.4754V20.8336H23.0588V19.3709C25.2142 19.1006 25.8457 17.455 25.8457 15.9754ZM20.6701 11.9846C20.6701 11.5151 20.9584 11.1025 21.686 10.9318V12.952C21.082 12.7528 20.6701 12.4825 20.6701 11.9846ZM23.0588 17.3623V15.399C23.6492 15.6124 24.0473 15.8827 24.0473 16.3807C24.0473 16.8359 23.7453 17.2058 23.0588 17.3623Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_857_909",
    x: 25.0851,
    y: 8.47047,
    width: 42.1231,
    height: 36.1124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.474418,
    dy: 0.474418
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.37209
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_857_909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_857_909",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_857_909",
    x: 0.627911,
    y: 0.785731,
    width: 38.2159,
    height: 34.1368,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.948835
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.18604
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_857_909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_857_909",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerPtp);
export default __webpack_public_path__ + "static/media/customer_ptp.4a1153fb3bf55ce581e616ff1701f028.svg";
export { ForwardRef as ReactComponent };